/* eslint-disable @typescript-eslint/naming-convention */
export enum WireRegion {
    canada = 'CANADA',
    united_states = 'UNITED_STATES',
    united_kingdom = 'UNITED_KINGDOM',
    north_america = 'NORTH_AMERICA',
    other = 'OTHER'
}
